"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinInput = void 0;
const React = require("react");
const react_code_input_1 = require("react-code-input");
/**
 * Provides a pin input.
 */
class PinInput extends React.Component {
    constructor(props) {
        super(props);
        this.clearCount = 0;
    }
    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.props.value &&
            [null, ""].indexOf(newProps.value) > -1) {
            this.clearCount++;
        }
    }
    render() {
        const { value, onInputChange, length } = this.props;
        if (!length) {
            throw new Error("length must be set and greater than 0");
        }
        return (React.createElement("span", { "data-test": "pin-input" },
            React.createElement(react_code_input_1.default, { key: this.clearCount, "data-test": "input", type: "text", fields: length, onChange: onInputChange, value: value || "", inputStyle: {
                    fontFamily: "monospace",
                    borderRadius: "6px",
                    border: "1px solid lightgrey",
                    // boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
                    margin: "4px",
                    // paddingLeft: "8px",
                    padding: 0,
                    width: "36px",
                    // flexGrow: 1,
                    textAlign: "center",
                    height: "42px",
                    fontSize: "32px",
                    boxSizing: "border-box",
                    color: "black",
                    backgroundColor: "white"
                } })));
    }
}
exports.PinInput = PinInput;
//# sourceMappingURL=index.js.map